import * as React from 'react';
import classcat from 'classcat';

import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import { CopyToClipboard } from '../../containers/DataExplorer/CopyToClipboard/CopyToClipboard';

import './AlphaIdCopy.scss';

interface AlphaIdCopyProps {
  alphaId: string;
  onCopy?: () => void;
  className?: string;
}

export const AlphaIdCopy = ({ alphaId, onCopy, className }: AlphaIdCopyProps) => {
  if (!alphaId) {
    return null;
  }

  return (
    <span className={classcat(['alpha-id-copy', className])}>
      <span className="alpha-id-copy__label">
        <FormattedMessageHelper id="edit.properties.alphaId" defaultMessage="Alpha ID" />:
      </span>
      <span className="alpha-id-copy__value">{alphaId}</span>
      <CopyToClipboard value={alphaId} className="copy-to-clipboard--alpha-id" onCopy={onCopy} />
    </span>
  );
};
